import RequestManager from "./RequestManager";

const getStatuses = async (domainId) => {
    const response = await RequestManager.get({
        url: `/monitoring/v1/${domainId}`
    });
    return response;
};

const Monitoring = {
    getStatuses
};

export default Monitoring;